import {
  Card,
  Col,
  Form,
  Row,
  Space,
  Table,
  Button
} from "antd";
import moment from "moment";
import { useEffect, useState } from "react";
import { POST } from "../../utils/apicalls";
import { API } from "../../config/api";
import { useNavigate } from "react-router-dom";
import { GrView } from "react-icons/gr";
import PageHeader from "../../admin/pageHeader/pageheader";
import jsPDF from "jspdf";
import "jspdf-autotable";

function InternshipPayement() {
  const [form] = Form.useForm();
  const [isLoading, setIsLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(100000);
  const [data, setData] = useState<any>([]);
  const [meta, setMeta] = useState<any>({});
  const navigate = useNavigate();

  const columns = [
    { title: "Intern Name", dataIndex: "internName" },
    { title: "Type of Payment", dataIndex: "PayementType" },
    {
      dataIndex: "internpayment",
      title: "Date",
      render: (date: any) => (date ? moment(date).format("DD/MM/YYYY") : "-"),
    },
    {
      dataIndex: "PayementAmount",
      title: "Amount",
    },
    {
      title: "Action",
      key: "id",
      render: (_: any, record: any) => (
        <Space size="middle">
          <GrView
            color="blue"
            size={20}
            onClick={() => navigate(`/Admin/InternshipIndex/updateInternship/${record.id}`)}
          />
        </Space>
      ),
    },
  ];

  const fetchIntern = async (page: any, take: any) => {
    try {
      setIsLoading(true);
      let obj = {
        query: form.getFieldValue("query"),
        page: page,
        take: take,
      };
      const url = API.LIST_INTERNSHIP_STUDENTS_DETAILS;
      const response: any = await POST(url, obj);
      setData(response?.data);
      setMeta(response?.meta);
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchIntern(page, pageSize);
  }, [page, pageSize]);

  const calculateGrandTotal = () => {
    return data.reduce(
      (acc: number, curr: any) => acc + Number(curr.PayementAmount || 0),
      0
    );
  };
  const generatePDF = () => {
    const doc = new jsPDF();
    doc.text("Internship Payments", 10, 10);

    const tableColumn = ["Intern Name", "Type of Payment", "Date", "Amount"];
    const tableRows = data.map((item: any) => [
      item.internName,
      item.PayementType,
      item.internpayment ? moment(item.internpayment).format("DD/MM/YYYY") : "-",
      item.PayementAmount,
    ]);

    doc.autoTable({ head: [tableColumn], body: tableRows });
    doc.save("internship_payments.pdf");
  };

  return (
    <div>
      <PageHeader />
      <Card>
        <Row justify="end" style={{ marginBottom: "10px" }}>
          <Button type="primary" onClick={generatePDF}>Download PDF</Button>
        </Row>
        <Table
          columns={columns}
          dataSource={data}
          pagination={{
            current: page,
            pageSize: pageSize,
            total: meta?.total,
            onChange: (page: number, pageSize: number) => {
              setPage(page);
              setPageSize(pageSize);
            },
          }}
        />
        <Row style={{ marginTop: "20px", textAlign: "right" }}>
          <Col span={24}>
            <h3>
              Grand Total: <span style={{ color: "green" }}>{calculateGrandTotal()}</span>
            </h3>
          </Col>
        </Row>
      </Card>
    </div>
  );
}

export default InternshipPayement;
